<navigation-dropdown [isNavigationDropdownButtonClassNeeded]="!withoutBorderOnFocus" [menuItems]="helpMenuItems" [showNewDesign]="true" [dropdownTitle]="'support_center' | localize">
  <i class="icon" [class.navigation-dropdown-icon-v2]="withoutBorderOnFocus" [uiType]="iconType" ui-icon gh-dropdown-toggle></i>
</navigation-dropdown>
